import { connect } from 'react-redux';
import { mapPlotMetadataToPlotId, mapPlotMetadataToDownloadText } from 'js/containers/legacy/GraphSection';
import { mapTextVariableNameToStaticLocalizedText } from 'js/helpers/localization';
import { show } from 'js/store/actions/modal';
import { fetchAndUpdateDownloadMenuMetadata } from 'js/store/actions/downloadMenu';
import GraphDownloadButton from 'js/components/legacy/GraphDownloadButton';
export default connect(function (state, ownProps) {
  return {
    plotId: mapPlotMetadataToPlotId(ownProps.plotMetadata),
    plotCountryCode: state.countryMetadata.metadata.countryCode,
    plotDownloadText: mapPlotMetadataToDownloadText(ownProps.plotMetadata),
    downloadDateRangeLabel: mapTextVariableNameToStaticLocalizedText('DOWNLOAD_DATA_DATE_RANGE_LABEL'),
    isMobileWidth: state.device.isMobileWidth
  };
}, function (dispatch) {
  return {
    launchDownloadModal: function launchDownloadModal(countryCode, plotId, props) {
      dispatch(fetchAndUpdateDownloadMenuMetadata(countryCode, plotId));
      dispatch(show('DownloadModal', props));
    }
  };
})(GraphDownloadButton);